import { toDate } from "~/application/utils/date-functions";
import type { ExtraOrderCost } from "~/application/types";
import { mapCostCategoryDTO } from "./mapCostCategoryDTO";
import { mapTravelerDTO } from "./mapTravelerDTO";
import type { ExtraOrderCostDTO } from "../dtos";

export const mapExtraOrderCostDTO = (data: ExtraOrderCostDTO): ExtraOrderCost => {
  return {
    uuid: data.uuid,
    costCategory: mapCostCategoryDTO(data.cost_category),
    traveler: mapTravelerDTO(data.traveler),
    proofLink: data.proof_link ?? undefined,
    orderId: data.order_uuid,
    orderItemId: data.order_item_uuid,
    protocol: data.protocol ?? undefined,
    tracker: data.tracker ?? undefined,
    value: Number(data.value),
    obs: data.obs ?? undefined,
    startAt: toDate(data.start_date),
    endAt: toDate(data.end_date),
    createdAt: toDate(data.created_at),
    exportedAt: data.exported_at ? toDate(data.exported_at) : undefined,
    flightItinerary: data.flight_itinerary?.map((segment) => ({
      flightNumber: segment.flight_number,
      airline: segment.airline,
      departureAirport: segment.departure_airport,
      departureDateTime: segment.departure_date_time,
      arrivalAirport: segment.arrival_airport,
      arrivalDateTime: segment.arrival_date_time,
    })),
    ticket: data.ticket ?? undefined,
    paymentMethodUuid: data.payment_method_uuid ?? undefined,
  };
};
